import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Hero = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S40};
  justify-content: space-between;
  min-height: 240px;
  padding: ${Spacing.S32};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  overflow: hidden;
`
export const IllustrationWrapper = styled.div`
  align-self: flex-end;
  flex-shrink: 0;
  width: 280px;
  max-width: 40%;
  margin-bottom: -90px;
  pointer-events: none;

  & > svg {
    display: block;
    width: 100%;
    height: auto;
  }
`
